// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_stroke2","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M10 10H21V21H10V10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"relativity"},"children":[{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 3H14V14H3V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","mask":"props.overlapMaskUrl_stroke2"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10 10H21V21H10V10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const RelativityIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'relativity',
    ref,
    icon: element,
  },
));

RelativityIcon.displayName = 'RelativityIcon';

export default RelativityIcon;
